import { useQuery } from '@tanstack/react-query'
import { Template, ITemplateFavorites } from '@templates/types'
import { api } from 'api'

/**
 * React Query API Query to fetch templates and template favorites.
 */
async function getTemplatesQuery() {
  const { data } = await api.get<Template[]>('/api/v1/account/template?with[]=folder')
  const favoritesResponse = await api.get<ITemplateFavorites[]>(
    '/api/v1/account/template/favorites',
  )
  const favorites = favoritesResponse?.data?.map(fav => fav.id)

  return data.map(d => {
    d.favorite = favorites.includes(d.id)
    return d
  })
}

export function useTemplatesQuery() {
  const query = useQuery<Template[]>({
    queryKey: ['getTemplatesWithFolderAndFavorites'],
    queryFn: getTemplatesQuery,
    refetchOnWindowFocus: false,
  })

  return query
}
